module.exports = __webpack_public_path__ + "static/media/sponsor2.4100a5ea.png";